<template>
    <div class="allMaterials">
<!--        下载全部投保材料和文书-->
        <div class="downloadBox">
            <el-button @click="downloadBtn" type="primary">下载全部投保材料</el-button>
        </div>
<!--        投保文书列表-->
        <div class="title">
            <p></p>
            <h4>投保文书列表</h4>
        </div>
        <avue-crud :data="data" :option="option" >
            <template slot="menu" slot-scope="scope" >
                <a :href="scope.row.all_url" target="_blank" style="color: #ffffff"><el-button type="primary">查看文件</el-button></a>
            </template>
        </avue-crud>
<!--        线索材料列表-->
        <div class="title">
            <p></p>
            <h4>线索材料列表</h4>
        </div>
        <avue-crud :data="clueData" :option="option1" >
            <template slot="menu" slot-scope="scope" >
                <a :href="scope.row.all_url" target="_blank" style="color: #ffffff"><el-button type="primary">查看文件</el-button></a>
            </template>
        </avue-crud>
<!--        保全法院的信息列表-->
        <div class="title">
            <p></p>
            <h4>保全法院的信息列表</h4>
        </div>
        <avue-crud :data="courtData" :option="option2" >
            <template slot="menu" slot-scope="scope" >
                <a :href="scope.row.all_url" target="_blank" style="color: #ffffff"><el-button type="primary">查看文件</el-button></a>
            </template>
        </avue-crud>
<!--        待客户确认保单保函信息列表-->
        <div class="title">
            <p></p>
            <h4>待客户确认保单保函信息列表</h4>
        </div>
        <avue-crud :data="warrantyData" :option="option3" >
            <template slot="menu" slot-scope="scope" >
                <a :href="scope.row.all_url" target="_blank" style="color: #ffffff"><el-button type="primary">查看文件</el-button></a>
            </template>
        </avue-crud>
<!--     待客户盖章投保单列表   -->
        <div class="title">
            <p></p>
            <h4>待客户盖章投保单列表</h4>
        </div>
        <avue-crud :data="awaitData" :option="option4" >
            <template slot="menu" slot-scope="scope" >
                <a :href="scope.row.all_url" target="_blank" style="color: #ffffff"><el-button type="primary">查看文件</el-button></a>
            </template>
        </avue-crud>
<!--      客户已盖章投保单列表  -->
        <div class="title">
            <p></p>
            <h4>客户已盖章投保单列表</h4>
        </div>
        <avue-crud :data="sealedData" :option="option5" >
            <template slot="menu" slot-scope="scope" >
                <a :href="scope.row.all_url" target="_blank" style="color: #ffffff"><el-button type="primary">查看文件</el-button></a>
            </template>
        </avue-crud>
<!--        保险公司收款信息列表-->
        <div class="title">
            <p></p>
            <h4>保险公司收款信息列表</h4>
        </div>
        <avue-crud :data="collectionData" :option="option6" >
            <template slot="menu" slot-scope="scope" >
                <a :href="scope.row.all_url" target="_blank" style="color: #ffffff"><el-button type="primary">查看文件</el-button></a>
            </template>
        </avue-crud>
<!--        客户缴费信息列表  -->
        <div class="title">
            <p></p>
            <h4>客户缴费信息列表</h4>
        </div>
        <avue-crud :data="PayData" :option="option7" >
            <template slot="menu" slot-scope="scope" >
                <a :href="scope.row.all_url" target="_blank" style="color: #ffffff"><el-button type="primary">查看文件</el-button></a>
            </template>
        </avue-crud>
<!--        正式保单保函等资料列表  -->
        <div class="title">
            <p></p>
            <h4>正式保单保函等资料列表</h4>
        </div>
        <avue-crud :data="formalData" :option="option8" >
            <template slot="menu" slot-scope="scope" >
                <a :href="scope.row.all_url" target="_blank" style="color: #ffffff"><el-button type="primary">查看文件</el-button></a>
            </template>
        </avue-crud>
    </div>
</template>

<script>
    import { downloadInsure, viewAllMaterials } from '../../../api/insure';

    export default {
        name: 'allMaterialsPage',
        data() {
            return {
                data: [],  //投保文书列表
                clueData:[], //线索材料列表
                courtData:[], //保全法院的信息列表
                warrantyData:[], //待确认保单保函信息列表
                awaitData:[],  //待客户盖章投保单列表
                sealedData:[], //客户已盖章投保单列表
                collectionData:[], //保险公司收款信息列表
                PayData:[],  //客户缴费信息列表
                formalData:[], //正式保单保函等资料列表

                option:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:240,  //操作栏宽度设置
                    column:[
                        {
                            label:'文件名称',
                            prop:'name'
                        }, {
                            label:'是否需要盖章',
                            prop:'is_need_sign_txt'
                        }, {
                            label:'是否已盖章',
                            prop:'is_sign_txt'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        },
                    ]
                },
                option1:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:240,  //操作栏宽度设置
                    column:[
                        {
                            label:'文件名称',
                            prop:'name'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        },
                    ]
                },
                option2:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:240,  //操作栏宽度设置
                    column:[
                        {
                            label:'文件名称',
                            prop:'name'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        },
                    ]
                },
                option3:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:240,  //操作栏宽度设置
                    column:[
                        {
                            label:'文件名称',
                            prop:'name'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        },
                    ]
                },
                option4:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:240,  //操作栏宽度设置
                    column:[
                        {
                            label:'文件名称',
                            prop:'name'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        },
                    ]
                },
                option5:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:240,  //操作栏宽度设置
                    column:[
                        {
                            label:'文件名称',
                            prop:'name'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        },
                    ]
                },
                option6:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:240,  //操作栏宽度设置
                    column:[
                        {
                            label:'文件名称',
                            prop:'name'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        },
                    ]
                },
                option7:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:240,  //操作栏宽度设置
                    column:[
                        {
                            label:'文件名称',
                            prop:'name'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        },
                    ]
                },
                option8:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:240,  //操作栏宽度设置
                    column:[
                        {
                            label:'文件名称',
                            prop:'name'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        },
                    ]
                },
            };
        },
        methods:{
            //下载全部文件
            downloadBtn(){
                this.$confirm('请确认是否下载全部投保材料 ', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    downloadInsure({case_id:this.$route.query.id}).then(res=>{
                        if (res.code==200){
                            const link = document.createElement('a'); //自己创建的a标签
                            link.href = res.data.download_url + '?v=' + Math.random();
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(res.data.download_url);
                            this.$message.success(res.msg);
                        }else {
                            this.$message.error(res.msg)
                        }
                    })
                }).catch(() => {

                });
            }
        },
        created() {
            viewAllMaterials({case_id:this.$route.query.id}).then(res=>{
                if (res.code==200){
                    this.data=res.data.baoxian_wenshu
                    this.clueData=res.data.xiansuo_cailiao
                    this.courtData=res.data.baoquan_fayuan
                    this.warrantyData=res.data.daiqueren
                    this.awaitData=res.data.daigaizhang
                    this.sealedData=res.data.yigaizhang
                    this.collectionData=res.data.shoukuan
                    this.PayData=res.data.jiaofei
                    this.formalData=res.data.zhengshi
                }else {
                    this.$message.error(res.msg)
                }
            })
        }
    };
</script>

<style scoped>
    .allMaterials{
        padding: 30px;
        background-color: #ffffff;
        border-radius: 5px;
    }
    .title{
        display: flex;
        align-items: center;
        color: #3b63f6;
    }
    .title>p{
        width: 5px;
        height: 18px;
        background-color: #3b63f6;
        margin-right: 10px;
    }
    /deep/.el-form{
        margin-bottom: 50px;
    }
    .downloadBox{
        margin: 20px 0px;
    }
</style>
